import { FieldValues, useFormContext, UseFormReturn } from 'react-hook-form';

export const ConnectForm = <T extends FieldValues = Record<string, unknown>>({
  children,
}: {
  children: (arg: UseFormReturn<T>) => JSX.Element;
}) => children(useFormContext<T>());
